import { Steps } from "antd";
import styled, { css } from "styled-components";

export const StyledList = styled.div`
    overflow-y: auto;
`;

export const StyledBottomSheetTop = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 8px;
    align-items: center;
`;

export const StyledAssortmentMatrixHeader = styled.div`
    padding: 16px;
    background-color: ${({ theme }) => theme.primaryBackground};
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const StyledAssortmentMatrixSteps = styled(Steps)`
    .ant-steps-item-title::after {
        top: 16px !important;
    }

    .ant-steps-item-icon {
        margin: 0 !important;
    }
`;

export const StyledAssortmentMatrixStepCircleIcon = styled.div<{
    $active: boolean;
    $finished: boolean;
}>`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.3s;

    ${({ $active, $finished, theme }) => {
        if ($active) {
            return css`
                background: ${theme.additionalTypographyColor};
                color: ${theme.primaryTypographyColor};

                svg {
                    color: ${theme.colors.white};
                }
            `;
        } else if ($finished) {
            return css`
                background: ${theme.successTypographyColor};
                color: ${theme.primaryTypographyColor};

                svg {
                    color: ${theme.colors.white};
                }
            `;
        } else {
            return css`
                background: ${theme.secondaryBorderColor};
                color: ${theme.secondaryTypographyColor};
            `;
        }
    }}
`;
